import React from 'react';
import PropTypes from 'prop-types';
import {
    PopupHeader,
    PopupActionButtons,
    MessagePreviewContent,
} from './Subcomponents/WhatsAppMessagePreview.subcomponents';

// Main Component: WhatsApp Message Preview
const WhatsAppMessagePreview = ({ show, invoice, onClose, onOpen }) => {
    if (!show || !invoice) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            width: '350px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
            zIndex: 9999,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <PopupHeader onClose={onClose} />
            <MessagePreviewContent invoice={invoice} />
            <PopupActionButtons invoice={invoice} onClose={onClose} onOpen={onOpen} />
        </div>
    );
};

WhatsAppMessagePreview.propTypes = {
    show: PropTypes.bool.isRequired,
    invoice: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
};

// Export subcomponents for backward compatibility
export {
    InvoiceDetailRow,
    InvoiceDetailsSection,
    DownloadLinkSection,
    MessageFooterText,
    PopupHeader,
    PopupActionButtons,
    MessagePreviewContent,
} from './Subcomponents/WhatsAppMessagePreview.subcomponents';

export default WhatsAppMessagePreview;
